import React from 'react';
import { Link } from 'react-router-dom';

// components
import BannerConsult from './Pages/BannerConsult';

const Footer = (props) => (
    <footer className="footer">
        {props.type !== 'work' &&
            props.type !== 'contact' &&
            props.type !== 'online-consult' && (
                <BannerConsult type={props.type} />
            )}
        <Link to={{ pathname: '/contact', state: { transition: 'fade' } }} />
        <div className="content-container">
            <div className="contactinfo">
                <div className="row">
                    <div className="col-xs-12 col-sm-4 col-md-4 no-padding">
                        <h4>Visit</h4>
                        <div className="adress">
                            <div>Eendrachtsplein 3 - Rotterdam</div>
                            <div>Linnaeusstraat 2C - Amsterdam</div>
                        </div>
                    </div>
                    <div className="col-xs-12  col-sm-4 col-md-3 no-padding">
                        <h4>Contact</h4>
                        <div className="contact-us">
                            <div className="email">
                                <a href="mailto:hello@friendsagency.com">
                                    hello@friendsagency.com
                                </a>
                            </div>
                            <div className="phone-number">010 414 0137</div>
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-4 col-md-5 no-padding">
                        <h4>Partner of</h4>
                        <div>
                            <Link to="/powered-by-meaning">
                                <div className="footer__logohub" />
                            </Link>
                            <Link
                                to={{
                                    pathname: '/about',
                                    state: {
                                        transition: 'fade',
                                        scrollToPartner: true,
                                    },
                                }}>
                                <div className="footer__logoff" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx